import { render } from "./Footer.vue?vue&type=template&id=5f5ea642"
const script = {}

import exportComponent from "E:\\wamp64\\www\\tusacan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__